import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NRSeverityLabel from '../../NRSeverityLabel/NRSeverityLabel';
import { camelCaseToHuman } from '../../../utils/utils';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock, MetaLine } from '../activityFeedHeaderShared';

function VulnerabilityRemediatedHeader({ entity, item, activity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity.cve} activity={activity} linkProps={linkProps} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {(entity.severity || entity.componentName) && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
              {entity.severity && <NRSeverityLabel severity={entity.severity} />}
              {entity.componentName && (
                <Typography variant="body2" color="text.secondary">
                  {[entity.componentName, entity.componentVersion, entity.componentVendor].filter(Boolean).join(' · ')}
                </Typography>
              )}
            </Box>
          )}
          {entity.vexStatus && entity.vexStatus !== 'UNSPECIFIED' && (
            <MetaLine>{`Status: ${camelCaseToHuman(entity.vexStatus, { preserveAcronyms: true })}`}</MetaLine>
          )}
          <DescriptionSecondary item={item} />
        </Box>
      }
    />
  );
}

export default VulnerabilityRemediatedHeader;
